import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { gerarLinkWhatsApp } from "../../utils/WhatsappLink";


function Header(props) {
    const token = localStorage.getItem("token");
    const navigate = useNavigate();

    const [showHeader, setShowHeader] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            if (currentScrollY > lastScrollY && currentScrollY > 50) {
                setShowHeader(false);
            } else {
                setShowHeader(true);
            }
            setLastScrollY(currentScrollY);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [lastScrollY]);

    const toggleMenu = () => setMenuOpen(!menuOpen);

    return (
        <div
            style={{
                width: "100%",
                backgroundColor: "#0b243d",
                height: "80px",
                display: "flex",
                justifyContent: "center",
                position: "fixed",
                top: showHeader ? "0" : "-85px",
                transition: "top 0.3s ease-in-out",
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    width: "90%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    color: "#fff",
                }}
            >
                {/* Logo */}
                <div
                    style={{
                        fontWeight: "bold",
                        fontSize: "18px",
                        cursor: "pointer",
                        color: "#ffc845"
                    }}
                    onClick={() => navigate("../")}
                >
                    <img src="/assets/logoClarea01.png" alt="Clarea Vital" style={{ height: "50px", marginTop: "5px" }} />
                </div>

                {/* Menu mobile toggle */}
                <div
                    onClick={toggleMenu}
                    style={{
                        display: "none",
                        cursor: "pointer",
                        flexDirection: "column",
                        gap: "4px",
                    }}
                    className="menu-toggle"
                >
                    <span style={{ width: "25px", height: "3px", backgroundColor: "#ffc845" }}></span>
                    <span style={{ width: "25px", height: "3px", backgroundColor: "#ffc845" }}></span>
                    <span style={{ width: "25px", height: "3px", backgroundColor: "#ffc845" }}></span>
                </div>

                {/* Menu */}
                <div
                    style={{
                        display: "flex",
                        gap: "20px",
                        alignItems: "center",
                    }}
                    className={`menu-items ${menuOpen ? "open" : "closed"}`}
                >
                    <p className="menu-button" onClick={() => navigate("../Planos")}
                        style={{ color: props.active === "planos" ? "#ffc845" : "#fff", display: props.active === "dashboard" ? "none" : "flex" }}>PLANOS</p>
                    <p className="menu-button" onClick={() => navigate("../Solucoes")}
                        style={{ color: props.active === "solucoes" ? "#ffc845" : "#fff", display: props.active === "dashboard" ? "none" : "flex" }}>SOLUÇÕES</p>
                    <p className="menu-button" onClick={() => navigate("../Nichos")}
                        style={{ color: props.active === "nichos" ? "#ffc845" : "#fff", display: props.active === "dashboard" ? "none" : "flex" }}>NICHOS</p>
                    <p className="menu-button" onClick={() => navigate("../SobreNos")}
                        style={{ color: props.active === "sobreNos" ? "#ffc845" : "#fff", display: props.active === "dashboard" ? "none" : "flex" }}>SOBRE NÓS</p>
                    <a
                        href={gerarLinkWhatsApp("Olá, tenho uma dúvida sobre os planos!")}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none", display: props.active === "dashboard" ? "none" : "flex" }}
                    >
                        <p className="menu-button" style={{ color: props.active === "duvidas" ? "#ffc845" : "#fff" }}>DÚVIDAS</p>
                    </a>
                    <PersonOutlineIcon className="menu-button" style={{ color: "#fff", display: token ? "none" : "block" }} onClick={() => navigate("../Login")} />
                    {props.active !== "dashboard" && (
                        <AccountCircleIcon className="menu-button" style={{ color: "#fff", display: token ? "block" : "none" }} onClick={() => navigate("../Dashboard")} />
                    )}
                </div>
            </div>

            {/* CSS inline para hover e responsivo */}
            <style>
                {`
                .menu-button {
                    cursor: pointer;
                    transition: all 0.3s ease;
                }
                .menu-button:hover {
                    color: #f9f2e4;
                    transform: scale(1.05);
                }

                @media (max-width: 768px) {
                    .menu-toggle {
                    display: flex !important;
                    }
                    .menu-items {
                    flex-direction: column;
                    position: absolute;
                    top: 60px;
                    left: 0;
                    width: 100%;
                    background-color: #0b243d;
                    padding: 10px 0;
                    }
                    .menu-items.closed {
                    display: none !important;
                    }
                    .menu-items.open {
                    display: flex !important;
                    }
                    .menu-items p {
                    padding: 10px;
                    text-align: center;
                    }
                }
                `}
            </style>
        </div>
    );
}

export default Header;
